import { render, staticRenderFns } from "./FormDistrictEdit.vue?vue&type=template&id=32b60ec8&scoped=true"
import script from "./FormDistrictEdit.vue?vue&type=script&lang=js"
export * from "./FormDistrictEdit.vue?vue&type=script&lang=js"
import style0 from "./FormDistrictEdit.vue?vue&type=style&index=0&id=32b60ec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b60ec8",
  null
  
)

export default component.exports